import React, { Component } from 'react'
import DeliveryButtons from './DeliveryButtons'

class OrderStrip extends Component {
    render() {
        return (
            <section className="order_strip">
                <h2 className="order_strip_title">想吃豆花？現在就訂</h2>
                <p className="order_strip_sub">新鮮手作豆花，外送直達你家</p>
                <DeliveryButtons variant="strip" />
            </section>
        );
    }
}

export default OrderStrip;
